/** @jsx jsx */
import { useState, useEffect} from 'react';
import { jsx, css } from '@emotion/react'
import { memo  } from 'react'
import PropTypes from 'prop-types'
import { useStaticQuery, graphql } from "gatsby"
import { Link } from 'gatsby'
import { Typography, Container } from '@material-ui/core';
import MainCard from '../components/MainCard'
import MainSection from '../components/MainSection'
import { AttachMoney, Home, AddComment, HowToReg as HowToRegIcon } from '@material-ui/icons';
import ProvidersConfigLayout from './ProvidersConfig'
import CustomizedStepper from '../components/elements/CustomizedStepper'
import Logo from '../assets/svg/afi-logo-v3.svg'
import MybambuLogo from '../assets/svg/myBambuMain.png'
import {  getLangs,  getUrlForLang,  getCurrentLangKey  } from 'ptz-i18n';
import Box from '@material-ui/core/Box';
import Footer from '../components/common/FooterFindep'
import { getUrl } from '../helpers/queryNavigate'

function FindepLayout({
  companyName,
  children,
  gradient,
  currentStep,
  iconos,
  menu,
  appContext,
  menuElement,  
  location,
  pageContext,
  broker,
  country
}) {  
  
  const data = useStaticQuery(graphql`
  {
    allComponentsJson(filter: {component: {eq: "footer-app"}}) {
      edges {
        node {
          footer {
            terminosyavisos {
              link
              texto
            }
            terminosyavisosafileft {
              link
              texto
            }
            terminosyavisosafiright {
              link
              texto
            }
            condusefarray {
              texto
              src {
                publicURL
              }
              link
            }
            buroarray {
              extra
              texto
              src {
                publicURL
              }
              link
            }
            imagestext {
              extra
              texto
              link
              src {
                publicURL
              }
            }
            leyendas {
              onetext
              link
              twotext
            }
            linkone {
              link
              texto
            }
            linktree {
              link
              texto
            }
            linktwo {
              link
              texto
            }
            otros {
              src {
                publicURL
              }
              link
            }
            company
            lang
            broker
            state
          }
        }
      }
    }
  }  
  `)
  const icons = iconos || { 1: <Home />, 2: <HowToRegIcon />, 3: <AddComment />, 4: <AttachMoney /> }  
 
  const url = location.pathname;
  const urlSearch = location.search || '';
  const { langs = [] } = pageContext
  const defaultLang = 'es'
  const langKey = getCurrentLangKey(langs, defaultLang, url)
  const homeLink = `/${langKey}/`
  const langsMenu = getLangs(langs, langKey, getUrlForLang(homeLink, url))
  const activeLanguage = langKey === 'en' ? 'EN' : 'ES'
  const navLinks = langKey === 'en'
    ? [
        { label: 'About Us', href: '/en/acerca' },
        { label: 'Contact', href: '/en/contacto' },
      ]
    : [
        { label: 'Quiénes Somos', href: '/es/acerca' },
        { label: 'Contacto', href: '/es/contacto' },
      ]

const bambuLogoCss = css`
    padding-left: 10px;
    width: 69px;
    margin-top: 17px;
    height: 69px;
`
const afiLogoCss = css`    
    width: 73px;
    margin-top: 15px;
    height: 73px;
`
const afiLogoNormalCss = css`    
    width: 100%;
    height: 73px;
    margin-top: 5px;
`

const headerShellCss = css`
  border-bottom: 1px solid rgba(27, 107, 74, 0.1);
  background: rgba(250, 250, 248, 0.96);
  backdrop-filter: blur(12px);
  overflow-x: clip;
`

const headerBarCss = css`
  display: flex;
  align-items: center;
  gap: 40px;
  min-height: 68px;
  padding: 0 8px;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 959px) {
    flex-wrap: wrap;
    gap: 16px;
    padding: 16px 0;
  }
`

const headerBrandCss = css`
  display: inline-flex;
  align-items: center;
  gap: 18px;
  flex-shrink: 0;

  @media (max-width: 959px) {
    min-width: 0;
    gap: 12px;
  }
`

const headerBrandLogoCss = css`
  width: 32px;
  height: 32px;
  object-fit: contain;
`

const headerBrandTextCss = css`
  color: #0d0d0d;
  font-family: 'Roboto', 'Helvetica Neue', Arial, sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.4;
  letter-spacing: 0.05em;
  white-space: nowrap;

  @media (max-width: 959px) {
    display: none;
  }
`

const headerNavCss = css`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 4px;
  flex: 1;

  @media (max-width: 959px) {
    display: none;
  }
`

const headerNavLinkCss = css`
  display: inline-flex;
  align-items: center;
  padding: 4px 14px;
  border-radius: 8px;
  color: #3d3d3d;
  text-decoration: none;
  font-size: 14.4px;
  font-weight: 500;
  line-height: 1.6;

  &:hover {
    background: rgba(255, 122, 69, 0.08);
  }
`

const langSwitchCss = css`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  padding: 3px;
  border-radius: 999px;
  background: #f0f0ec;
  flex-shrink: 0;

  @media (max-width: 959px) {
    margin-left: auto;
  }
`

const langButtonCss = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 44px;
  padding: 6px 13px;
  border-radius: 999px;
  color: #6b7280;
  text-decoration: none;
  font-size: 12.8px;
  font-weight: 600;
  line-height: 1;
`

const langButtonActiveCss = css`
  border: 1px solid #ff7a45;
  background: #ffffff;
  color: #ff7a45;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.12);
`

const mobileHeaderActionsCss = css`
  display: none;

  @media (max-width: 959px) {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    margin-left: auto;
  }
`

const hamburgerButtonCss = css`
  display: none;

  @media (max-width: 959px) {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 5px;
    width: 44px;
    height: 44px;
    border: 0;
    border-radius: 12px;
    background: transparent;
    cursor: pointer;
    padding: 0;
  }
`

const hamburgerLineCss = css`
  width: 28px;
  height: 3px;
  border-radius: 999px;
  background: #ff7a45;
`

const mobileMenuCss = css`
  display: none;

  @media (max-width: 959px) {
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: 100%;
    padding: 4px 0 12px;
  }
`

const mobileMenuLinkCss = css`
  display: inline-flex;
  align-items: center;
  min-height: 42px;
  padding: 0 4px;
  color: #3d3d3d;
  text-decoration: none;
  font-size: 15px;
  font-weight: 500;
  line-height: 1.5;
`

const [estado,setEstado]=useState(country)
const [brokerflujo,setBroker]=useState(null)
const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

useEffect(() => {  
  async function cambioSession(){
    let getEstado=JSON.parse( sessionStorage.getItem("afiStateShort"))    
    if(estado !== getEstado){
      setEstado(getEstado)      
    }else{      
      setTimeout(() => { cambioSession() }, 5000);
    }
    
  }  
    cambioSession()
}, [estado])

useEffect(() => {  
  let flujo=JSON.parse( sessionStorage.getItem("flujo")) 
  if(flujo?.broker ==="bambu"){
    setBroker(flujo.broker)
  }
  }, [])


  return (
    <ProvidersConfigLayout appContext={appContext} companyName={companyName} estado={estado}>      
        <MainCard>
          <MainSection gradient={gradient}>
              <header css={headerShellCss}>
                <Container maxWidth="xl">
                  <nav css={headerBarCss} role="navigation" aria-label={langKey === 'en' ? 'Main navigation' : 'Navegación principal'}>
                    <div css={headerBrandCss}>
                      <a href="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '18px', textDecoration: 'none' }}>
                        <img
                          src={Logo}
                          rel="nofollow noopener noreferrer"
                          alt="Apoyo Financiero logo"
                          css={headerBrandLogoCss}
                        />
                        <div css={headerBrandTextCss}>Apoyo Financiero</div>
                      </a>
                      {brokerflujo !== null ? (
                        <div style={{ borderLeft: '2px solid rgba(27, 107, 74, 0.12)', paddingLeft: '12px', height: '40px', display: 'flex', alignItems: 'center' }}>
                          <img src={MybambuLogo} rel="nofollow noopener noreferrer" alt="MyBambu logo" css={bambuLogoCss} />
                        </div>
                      ) : null}
                    </div>

                    <div css={headerNavCss}>
                      {navLinks.map((link) => (
                        <a key={link.label} href={link.href} css={headerNavLinkCss}>
                          {link.label}
                        </a>
                      ))}
                    </div>

                    <div css={mobileHeaderActionsCss}>
                      <div css={langSwitchCss} role="group" aria-label={langKey === 'en' ? 'Language selector' : 'Selector de idioma'}>
                        {langsMenu.map((lang) => {
                          const buttonLabel = lang.langKey === 'en' ? 'EN' : 'ES'
                          return (
                            <Link
                              key={lang.langKey}
                              to={`${lang.link}${urlSearch}`}
                              css={[langButtonCss, buttonLabel === activeLanguage && langButtonActiveCss]}
                              aria-pressed={buttonLabel === activeLanguage}
                              aria-label={langKey === 'en'
                                ? `Switch to ${buttonLabel === 'EN' ? 'English' : 'Spanish'}`
                                : `Cambiar a ${buttonLabel === 'EN' ? 'inglés' : 'español'}`}
                            >
                              {buttonLabel}
                            </Link>
                          )
                        })}
                      </div>

                      <button
                        type="button"
                        css={hamburgerButtonCss}
                        aria-label={langKey === 'en' ? 'Open navigation menu' : 'Abrir menú de navegación'}
                        aria-expanded={mobileMenuOpen}
                        onClick={() => setMobileMenuOpen((current) => !current)}
                      >
                        <span css={hamburgerLineCss} />
                        <span css={hamburgerLineCss} />
                        <span css={hamburgerLineCss} />
                      </button>
                    </div>

                    <div
                      css={css`
                        @media (max-width: 959px) {
                          display: none;
                        }
                      `}
                    >
                      <div css={langSwitchCss} role="group" aria-label={langKey === 'en' ? 'Language selector' : 'Selector de idioma'}>
                        {langsMenu.map((lang) => {
                          const buttonLabel = lang.langKey === 'en' ? 'EN' : 'ES'
                          return (
                            <Link
                              key={lang.langKey}
                              to={`${lang.link}${urlSearch}`}
                              css={[langButtonCss, buttonLabel === activeLanguage && langButtonActiveCss]}
                              aria-pressed={buttonLabel === activeLanguage}
                              aria-label={langKey === 'en'
                                ? `Switch to ${buttonLabel === 'EN' ? 'English' : 'Spanish'}`
                                : `Cambiar a ${buttonLabel === 'EN' ? 'inglés' : 'español'}`}
                            >
                              {buttonLabel}
                            </Link>
                          )
                        })}
                      </div>
                    </div>
                  </nav>

                  {mobileMenuOpen ? (
                    <div css={mobileMenuCss}>
                      {navLinks.map((link) => (
                        <a
                          key={link.label}
                          href={link.href}
                          css={mobileMenuLinkCss}
                          onClick={() => setMobileMenuOpen(false)}
                        >
                          {link.label}
                        </a>
                      ))}
                    </div>
                  ) : null}
                </Container>
              </header>

                
              <Box component="main" sx={{ p: 0, backgroundColor: '#fafaf8' }}>
                {/* <Box sx={{ flexGrow: 0,  display: { xs: 'flex', md: 'none' }  }}> */}
                  {(currentStep >= 0 && currentStep !== null) && <CustomizedStepper iconos={icons} currentStep={currentStep} />}
                {/* </Box> */}
                {children}
                <Footer broker={broker} companyName={companyName} data={data} estado={estado} lang={langKey} />
              </Box>
            
          </MainSection>
        </MainCard>
    </ProvidersConfigLayout>
  )
}

FindepLayout.propTypes = {
  companyName: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  currentStep: PropTypes.number,
  gradient: PropTypes.bool,
  menu: PropTypes.bool,
  menuElement: PropTypes.node,
}

export default memo(FindepLayout)
